import React, { Fragment } from "react";
import { useSelector } from "react-redux";

import { deleteError } from "@redux/modules/value/errors/errors.module";
import { getErrors } from "@redux/modules/value/errors/errors.selectors";
import { useThunkDispatch } from "@redux/dispatcher";

import ErrorMessage from "./errorMessages.component";

const ErrorMessages = () => {
    const dispatch = useThunkDispatch();
    const errors = useSelector(getErrors);

    const handleDelete = (err: any) => {
        dispatch(deleteError(err));
    };

    return (
        <Fragment>
            {errors?.map((err, index) => (
                <ErrorMessage
                    key={index}
                    message={err.message}
                    handleDelete={() => {
                        handleDelete(err);
                    }}
                />
            ))}
        </Fragment>
    );
};

export { ErrorMessages };
